import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { Injectable, inject } from "@angular/core";
import { EMPTY, Observable, catchError, take, tap } from "rxjs";
import { TreatmentState, UpsertTreatment } from "../store";
import { Store } from "@ngrx/store";
import { TreatmentModel } from "../models/treatment.model";
import { TreatmentService } from "./treatment.lib.service";
import { NotificationService } from "libs/tm-common/src/lib/services/notification.lib.service";

@Injectable({
	providedIn: 'root'
})
export class TreatmentResolver {
	private treatmentService = inject(TreatmentService);
	private notificationService = inject(NotificationService);
	private store = inject<Store<TreatmentState>>(Store);
	private router = inject(Router);


	resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<TreatmentModel> {
		return this.treatmentService.getTreatment(route.params.id).pipe(
			take(1),
			tap((treatment: TreatmentModel) =>
				this.store.dispatch(new UpsertTreatment({ treatment }))
			),
			catchError(() => {
				this.notificationService.showErrorMessage("ResolveTreatmentError", "", 5000);
				this.router.navigate(["/dashboard"]);
				return EMPTY;
			})
		);
	}
}
